import Api from "./api";
import { hideLoading, showLoading } from "react-redux-loading-bar";
import {
  GET_P2P_ADS,
  GET_P2P_ORDERS,
  GET_P2P_OVERVIEW_STATS,
  GET_P2P_TRANSACTIONS,
  GET_P2P_WALLET_STATS,
  GET_USER_P2P_ADS,
  GET_USER_P2P_ORDERS,
  GET_USER_P2P_WALLET_STATS,
  P2P_ERROR,
  P2P_LOADING,
  UPDATE_ADS_PAGE,
  UPDATE_P2P_ACTIVE_TAB,
  UPDATE_P2P_ADS_ACTIVE_TAB,
  UPDATE_P2P_ADS_SEARCH,
  UPDATE_P2P_ADS_STATUS,
  UPDATE_P2P_ORDERS_ACTIVE_TAB,
  UPDATE_P2P_ORDERS_SEARCH,
  UPDATE_P2P_ORDERS_STATUS,
  UPDATE_USER_P2P_ACTIVE_TAB,
  UPDATE_USER_P2P_ADS_ACTIVE_STATUS,
  UPDATE_USER_P2P_ORDERS_ACTIVE_STATUS,
} from "../Types/Types";
import { customToast } from "../../utils/customToast";

export const getP2POverviewStats = (query) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getP2POverviewStats(query);
      dispatch({
        type: GET_P2P_OVERVIEW_STATS,
        payload: response.data,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getP2PWalletStats = () => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getP2PWalletStats();
      dispatch({
        type: GET_P2P_WALLET_STATS,
        payload: response.data,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getP2POrders = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const { p2pOrdersActiveTab, p2pOrdersActiveStatus, p2pOrdersSearch } =
        getState().p2p;

      const query = {
        type: p2pOrdersActiveTab,
        status: p2pOrdersActiveStatus,
        keyword: p2pOrdersSearch,
      };

      const response = await Api.getP2POrders(query);

      dispatch({
        type: GET_P2P_ORDERS,
        payload: response.data.rows,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getP2PTransactions = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getP2PTransactions();

      dispatch({
        type: GET_P2P_TRANSACTIONS,
        payload: response.data,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getP2PAds = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const {
        p2pAdsActiveTab,
        p2pAdsActiveStatus,
        p2pAdsPage,
        p2pAdsTotalPages,
        p2pAdsSearch,
      } = getState().p2p;

      // const currentPage = p2pAdsPage[p2pAdsActiveTab][currentStatus];

      const query = {
        type: p2pAdsActiveTab,
        // page: currentPage,
        status: p2pAdsActiveStatus,
        keyword: p2pAdsSearch,
      };
      const response = await Api.getP2PAds(query);
      dispatch({
        type: GET_P2P_ADS,
        payload: response.data.rows,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getUserP2PWalletStats = (id) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getUserP2PWalletStats(id);
      dispatch({
        type: GET_USER_P2P_WALLET_STATS,
        payload: response.data,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getUserP2POrders = (id) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getUsersP2POrders(id);
      dispatch({
        type: GET_USER_P2P_ORDERS,
        payload: response.data.rows,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const getUserP2PAds = (id) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const response = await Api.getUsersP2PAds(id);
      console.log("response", response);

      dispatch({
        type: GET_USER_P2P_ADS,
        payload: response.data.rows,
      });
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const updateAdStatus = (ad_id, status, successCallback) => {
  return async (dispatch, getState) => {
    dispatch({ type: P2P_LOADING });
    dispatch(showLoading());
    try {
      const payload = {
        is_active: status,
      };
      const response = await Api.updateAdStatus(ad_id, payload);

      // console.log(response);
      customToast.success(`ad status updated`);
      dispatch({
        type: GET_USER_P2P_ADS,
        payload: response.data.rows,
      });
      dispatch(hideLoading());

      if (response) {
        if (successCallback && typeof successCallback === "function") {
          successCallback(response);
        }
      }
      dispatch(hideLoading());
    } catch (error) {
      if (error.response) return customToast.error(error.response.data);
      if (error.request) return console.log(error.request);
      dispatch({ type: P2P_ERROR });
      return console.log(error.message);
    } finally {
      dispatch(hideLoading());
    }
  };
};

export const updateP2pActiveTab = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ACTIVE_TAB, payload });
  };
};

export const updateP2PAdsActiveTab = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ADS_ACTIVE_TAB, payload });
  };
};

export const updateP2PAdsActiveStatus = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ADS_STATUS, payload });
  };
};
export const updateP2POrdersActiveStatus = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ORDERS_STATUS, payload });
  };
};

export const updateP2POrdersActiveTab = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ORDERS_ACTIVE_TAB, payload });
  };
};

export const updateP2PAdsPage = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_ADS_PAGE, payload });
  };
};

export const updateUserP2PActiveTab = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_USER_P2P_ACTIVE_TAB, payload });
  };
};

export const updateUserP2POrdersActiveStatus = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_USER_P2P_ORDERS_ACTIVE_STATUS, payload });
  };
};

export const updateUserP2PAdsActiveStatus = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_USER_P2P_ADS_ACTIVE_STATUS, payload });
  };
};

export const updateP2pAdsSearch = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ADS_SEARCH, payload });
  };
};

export const updateP2pOrdersSearch = (payload) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_P2P_ORDERS_SEARCH, payload });
  };
};
